module.exports = __webpack_public_path__ + "static/img/a12.933c2e1b.png";